import React, { useState, useEffect } from "react";
import { Modal } from "reactstrap";
import LoginForms from "./LoginForm";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";
import { setAuthError } from "../../actions/session";
import { getCookie } from "../cookies";
import useAuth from "../../hooks/useAuth";

const LoginModal = ({
  history,
  open,
  onClose,
  fromContact = false,
  listingAgent = null,
  listingID = null,
  fromHomePublic = false,
}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(open);
  const isAuthenticated = useSelector((state) => state.session.isAuthenticated);
  const error = useSelector((state) => state.session.error);
  const { refreshToken, logout, onSuccess } = useAuth({ history, listingID });

  const handleClose = () => {
    dispatch({ type: "RESET_STATE" });
    onClose();
    dispatch(setAuthError(false));
  };

  useEffect(() => {
    if (open === true) {
      const authDetails = getCookie("authDetails");
      if (!authDetails) {
        setIsOpen(true);
      } else {
        refreshToken();
      }
    } else {
      setIsOpen(false);
    }
  }, [open, refreshToken]);

  useEffect(() => {
    if (isAuthenticated && open) {
      onSuccess();
    }
  }, [isAuthenticated, open, onSuccess]);

  useEffect(() => {
    if (error && open) {
      logout();
      setIsOpen(true);
    }
  }, [error, open, logout]);

  return (
    <>
      <Modal
        fade={false}
        centered
        isOpen={isOpen}
        animation={true}
        toggle={handleClose}
        className={"login-modal"}
      >
        <LoginForms
          history={history}
          fromHomePublic={fromHomePublic}
          onClose={handleClose}
          fromContact={fromContact}
          listingAgent={listingAgent}
          listingID={listingID}
        />
      </Modal>
    </>
  );
};

export default LoginModal;
